// Single permit shared by every forced-reload mechanism (chunk-load recovery, version refresh):
// whichever fires first takes the slot, the others back off until the cooldown expires.
export const RELOAD_PERMIT_STORAGE_KEY = "bx-app-reload-last-reload-at";
export const RELOAD_COOLDOWN_MS = 60_000;

export function tryAcquireReloadPermit(): boolean {
  try {
    const lastReloadAt = Number(window.sessionStorage.getItem(RELOAD_PERMIT_STORAGE_KEY));
    const isWithinCooldown = Number.isFinite(lastReloadAt) && Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS;
    if (isWithinCooldown) {
      return false;
    }

    window.sessionStorage.setItem(RELOAD_PERMIT_STORAGE_KEY, String(Date.now()));
    return true;
  } catch {
    // Without a persisted guard a reload could loop forever, so never reload when storage is unavailable
    return false;
  }
}
